import { motion, AnimatePresence } from 'framer-motion';
import { X, Users } from 'lucide-react';

interface RACIModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function RACIModal({ isOpen, onClose }: RACIModalProps) {
  if (!isOpen) return null;
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="bg-gradient-to-br from-slate-900 via-green-900 to-slate-900 rounded-2xl max-w-5xl w-full my-8 border border-green-500/30 shadow-2xl shadow-green-500/20"
          >
            <div className="relative p-8 border-b border-green-500/30">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-gradient-to-br from-green-500 to-emerald-500 rounded-xl">
                    <Users className="w-10 h-10 text-white" />
                  </div>
                  <div>
                    <h2 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400">
                      Rôles & Responsabilités (RACI)
                    </h2>
                    <p className="text-gray-400 mt-1 text-lg">Norme obligatoire dans les Spécifications d'exigences</p>
                  </div>
                </div>
                <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-lg transition-colors">
                  <X className="w-6 h-6 text-gray-400" />
                </button>
              </div>
            </div>
            <div className="p-8 space-y-8 max-h-[calc(100vh-300px)] overflow-y-auto">
              <div className="bg-gradient-to-r from-green-600/20 via-emerald-600/20 to-green-600/20 rounded-xl p-8 border-2 border-green-500/50">
                <h3 className="text-2xl font-bold text-center text-white mb-4">RACI : Clarifier les Rôles</h3>
                <p className="text-gray-300 text-center text-lg">
                  RACI définit qui est <strong className="text-white">Responsable</strong> (R), qui <strong className="text-white">Approuve</strong> (A), 
                  qui est <strong className="text-white">Consulté</strong> (C), qui est <strong className="text-white">Informé</strong> (I).
                </p>
              </div>
              <div className="bg-gradient-to-br from-green-500/10 to-emerald-500/10 rounded-xl p-6 border border-green-500/30">
                <h4 className="text-xl font-bold text-white mb-4">KPI : RACI publié 100% + revu 90j</h4>
                <p className="text-gray-300">Le RACI doit être publié pour 100% des projets et revu tous les 90 jours.</p>
              </div>
            </div>
            <div className="p-6 border-t border-green-500/30 bg-slate-900/50">
              <div className="flex items-center justify-end">
                <button onClick={onClose} className="px-6 py-3 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-xl hover:from-green-600 hover:to-emerald-600 transition-all duration-200 font-semibold shadow-lg shadow-green-500/20 hover:shadow-green-500/40 hover:scale-105">
                  Fermer
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}

